import axios from "axios";
export const state = {
    save_status: false,
    recipes: [],
    recipes_cart: [],
    expected_output:[],
    actual_output:[]
};
export const getters = {
    SaveStatus: state => state.save_status,
    Recipes: state => state.recipes.data,
    RecipesCart: state => state.recipes_cart,
    ExpectedOutput: state => state.expected_output.data,
    ActualOutput: state => state.actual_output.data,
};

export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_RECIPE(state, newValue) {
        state.recipes = newValue
    },
    SET_RECIPE_CART(state, newValue) {
        state.recipes_cart = newValue
    }, 
    SET_EXPECTED_OUTPUT(state, newValue) {
        state.expected_output = newValue
    }, 
    SET_ACTUAL_OUTPUT(state, newValue) {
        state.actual_output = newValue
    },  
};

export const actions = {

    // Recipes Cart
    fetchRecipesCart({ commit }) {
        axios.get(`recipes_cart`).then(ec_res => {
            commit('SET_RECIPE_CART', ec_res.data)
        })
    }, 

    addToRecipesCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('recipes_cart',payload).then(() => {
            dispatch('fetchRecipesCart');
            let message = { 'msg': `Ingredient added to cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Ingredient to cart "+error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editRecipesCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`recipes_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipesCart');
            let message = { 'msg': `Ingredient ${payload.name} in cart updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error on updating Recipe Item in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteRecipesCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`recipes_cart/${payload.id}`).then(() => {
            dispatch('fetchRecipesCart');
            let message = { 'msg': `Ingredient ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_RECIPE_CART', false)
            let message = { 'msg': "Error on deleting Ingredient from cart "+error }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchRecipes({ commit }, payload) {
        axios.post(`fetchingredients`, payload).then(ec_res => {
            commit('SET_RECIPE', ec_res.data)
        })
    },

    addRecipes({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('recipes',payload).then(() => {
            dispatch('fetchRecipesCart');
            let message = { 'msg': `Ingredients for Item ${payload.name} added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Ingredients" }
            dispatch('notification/error', message, { root: true })
        })
    },
    editRecipes({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`recipes/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = { 'msg': `Ingredient ${payload.recipe} for product ${payload.product} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Ingredient" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteRecipes({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`recipes/${payload.id}`).then(() => {
            dispatch('fetchRecipes');
            let message = { 'msg': `Ingredient ${payload.recipe} for product ${payload.product} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Ingredient"}
            dispatch('notification/error', message, { root: true })
        })
    },


    changeBase({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`change_base/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = { 'msg': `Ingredient ${payload.recipe} has been set as base for product ${payload.product}` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in setting base Ingredient"}
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchExpectedOutput({ commit }, payload) {
        axios.post(`fetch_expectedoutput`, payload).then(ec_res => {
            commit('SET_EXPECTED_OUTPUT', ec_res.data)
        })
    },

    fetchActualOutput({ commit }, payload) {
        axios.post(`fetch_actualoutput`, payload).then(ec_res => {
            commit('SET_ACTUAL_OUTPUT', ec_res.data)
        })
    },

    editOutput({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`expected_output/${payload.id}`, payload).then(() => {
            dispatch('fetchExpectedOutput');
            let message = { 'msg': `Output for product ${payload.product} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Output" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteOutput({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`expected_output/${payload.id}`).then(() => {
            dispatch('fetchExpectedOutput');
            let message = { 'msg': `Output for product ${payload.product} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Output"}
            dispatch('notification/error', message, { root: true })
        })
    },

    confirmOutput({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`expected_output/${payload.id}`).then(() => {
            dispatch('fetchExpectedOutput');
            dispatch('fetchActualOutput');
            let message = { 'msg': `Output for product ${payload.product} cofirmed successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in cofirming Output"}
            dispatch('notification/error', message, { root: true })
        })
    },
};